export const enum NoticeRibbonType {
    error = 'error',
    warning = 'warning',
    success = 'info',
    critical = 'critical',
}
